// Central content for the SoftPro landing page (Dutch copy).
import {
  SprayCan,
  Home,
  Building2,
  Grid3x3,
  ShieldCheck,
  Leaf,
  Clock,
  Droplets,
  BadgeCheck,
  ArrowUpRight,
  Paintbrush,
  Umbrella,
  ClipboardCheck,
  FileText,
  SlidersHorizontal,
  Users,
} from "lucide-react";

export const CONTACT = {
  phone: "+31 85 060 55 89",
  phoneHref: "tel:+31850605589",
  email: "info@soft-pro.nl",
  address: "Heyenerf 24, Harskamp, 6732CA",
};

export const SERVICES = [
  {
    id: "dakreiniging",
    path: "/dakreiniging",
    title: "Dakreiniging",
    icon: SprayCan,
    text: "Bescherm de levensduur van je dak. Wij verwijderen mos, algen en vuil op een veilige, duurzame manier — je dak ziet er weer als nieuw uit.",
    image:
      "https://images.pexels.com/photos/35153375/pexels-photo-35153375.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "lg:col-span-3",
  },
  {
    id: "gevelreiniging",
    path: "/gevelreiniging",
    title: "Gevelreiniging",
    icon: Home,
    text: "Laat jouw gevel stralen als nooit tevoren met onze zachte lage-druk methode. Effectief tegen vuil en algen, zonder schade aan de ondergrond.",
    image:
      "https://images.pexels.com/photos/18078684/pexels-photo-18078684.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "lg:col-span-3",
  },
  {
    id: "dakcoating",
    path: "/dakcoating",
    title: "Dakcoating",
    icon: Paintbrush,
    text: "Geef je dak een beschermende, waterafstotende coating. Frisse kleur, langere levensduur en minder aangroei van mos en algen.",
    image:
      "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-2",
  },
  {
    id: "impregneren",
    path: "/dak-en-gevelimpregnering",
    title: "Dak- en gevelimpregnering",
    icon: Umbrella,
    text: "Een onzichtbare, waterafstotende laag die vocht en vuil buiten houdt. Zo blijft je gevel of dak langer schoon en droog.",
    image:
      "https://images.unsplash.com/photo-1771502044392-2336308d0c54?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    span: "lg:col-span-2",
  },
  {
    id: "terras",
    path: "/terras-reinigen",
    title: "Terras- en opritreiniging",
    icon: Grid3x3,
    text: "Van keramische tegels tot opritten en composiet vlonders: wij pakken groene aanslag en vuil grondig aan voor een frisse buitenruimte.",
    image:
      "https://images.pexels.com/photos/29952419/pexels-photo-29952419.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "lg:col-span-2",
  },
  {
    id: "bedrijfspand",
    path: "/bedrijfspand-reinigen",
    title: "Bedrijfspandreiniging",
    icon: Building2,
    text: "Een schoon pand is het visitekaartje van je bedrijf. Wij reinigen gevels, damwanden en beplating professioneel en representatief.",
    image:
      "https://images.pexels.com/photos/16898979/pexels-photo-16898979.jpeg?auto=compress&cs=tinysrgb&w=1200",
    span: "lg:col-span-6",
  },
];

export const BENEFITS = [
  { icon: Droplets, label: "Reiniging met lage druk" },
  { icon: ShieldCheck, label: "Veilig, geen schade" },
  { icon: Leaf, label: "100% biologisch afbreekbaar" },
  { icon: Clock, label: "Langdurig resultaat" },
  { icon: BadgeCheck, label: "Gratis proefstuk" },
  { icon: ArrowUpRight, label: "Geen hoogwerkers nodig" },
];

export const STEPS = [
  {
    n: "01",
    title: "Offerte aanvragen",
    text: "Vertel ons wat je wilt laten reinigen en stuur enkele foto's mee. Zo kunnen we de situatie en werkzaamheden alvast beoordelen.",
  },
  {
    n: "02",
    title: "Inspectie en persoonlijk advies",
    text: "We beoordelen de vervuiling en ondergrond en adviseren de juiste reinigingsmethode. Daarna ontvang je een duidelijke, vrijblijvende offerte.",
  },
  {
    n: "03",
    title: "Reiniging en eindcontrole",
    text: "Na akkoord plannen we de werkzaamheden in. We voeren de reiniging zorgvuldig uit en controleren het resultaat na afloop.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Reiniging met lage druk",
    text: "We stemmen de werkdruk en behandeling af op het materiaal, de vervuiling en de staat van de ondergrond.",
  },
  {
    n: "02",
    title: "Vervuiling gericht behandeld",
    text: "De reinigingsoplossing pakt algen, mos, schimmel en groene aanslag aan, in plaats van alleen het zichtbare vuil weg te spuiten.",
  },
  {
    n: "03",
    title: "Langer een verzorgde uitstraling",
    text: "Door organische vervuiling gericht te behandelen, blijft het oppervlak doorgaans langer schoon en verzorgd.",
  },
];

export const GALLERY = [
  {
    title: "Gevelreiniging woning",
    meta: "Complete voorgevel",
    before: "/woning-b.webp",
    after: "/woning-a.webp",
  },
  {
    title: "Gevelreiniging bedrijfspand",
    meta: "185 m²",
    before: "/hero-before.jpeg",
    after: "/hero-after.jpeg",
  },
];

export const PROJECTS = [
  {
    title: "Gevelreiniging Amersfoort",
    meta: "185 m²",
    text: "Gevel zacht gereinigd met de Softwash-methode. Alle aanslag veilig verwijderd — weer een frisse, nette gevel.",
    image:
      "https://images.unsplash.com/photo-1744551433098-af66780e161e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "Bedrijfspand IJsselstein",
    meta: "920 m²",
    text: "920 m² gevel gereinigd en geïmpregneerd. Vuil verwijderd, gevel extra beschermd. Het pand oogt weer strak.",
    image:
      "https://images.unsplash.com/photo-1517816981644-e0e3de7743e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
  {
    title: "Dakreiniging Zeewolde",
    meta: "245 m²",
    text: "Dak met rode betonpannen professioneel gereinigd. Mos, algen en vuil volledig verwijderd zonder schade.",
    image:
      "https://images.unsplash.com/photo-1563993356056-b23a9cd265ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  },
];

export const STATS = [
  { value: 240, suffix: "+", label: "Panden gereinigd in 2025" },
  { value: 100, suffix: "%", label: "Tevredenheidsgarantie" },
  { value: 4, suffix: " jaar", label: "Garantie met impregneren" },
  { value: 2, suffix: " min", label: "Offerte aanvragen" },
];

export const TRUST_POINTS = [
  { icon: ClipboardCheck, label: "Vrijblijvende inspectie" },
  { icon: FileText, label: "Duidelijke offerte vooraf" },
  { icon: SlidersHorizontal, label: "Behandeling op maat" },
  { icon: Users, label: "Voor particulier en bedrijf" },
];

export const REVIEWS = [
  {
    name: "Mark de Vries",
    place: "Amersfoort",
    text: "Ongelooflijk resultaat op onze gevel. Het proefstuk overtuigde ons meteen. Netjes werk, vriendelijke jongens en een eerlijke prijs.",
    rating: 5,
  },
  {
    name: "Sanne Bakker",
    place: "Soest",
    text: "Ons dak zat vol met mos. Na de behandeling ziet het er weer als nieuw uit. Geen hogedruk, dus geen schade. Echt een aanrader!",
    rating: 5,
  },
  {
    name: "Bakkerschat B.V.",
    place: "Bedrijfspand",
    text: "2800 m² damwanden gereinigd. Strak gepland, professioneel uitgevoerd en het pand is weer representatief. Top samenwerking.",
    rating: 5,
  },
  {
    name: "Peter Jansen",
    place: "Zeewolde",
    text: "Vrijblijvende offerte binnen een dag, gratis proefstuk en een blinkend schoon terras als eindresultaat. Zeer tevreden.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Wat is softwash?",
    a: "Softwash is een professionele reinigingsmethode waarbij lage waterdruk wordt gecombineerd met een zorgvuldig afgestemde reinigingsoplossing. De behandeling is gericht op het verwijderen van algen, mos, schimmel en groene aanslag van daken, gevels en andere buitenoppervlakken.",
  },
  {
    q: "Voor welke ondergronden is softwash geschikt?",
    a: "Softwash kan onder andere worden toegepast op dakpannen, bakstenen gevels, stucwerk, gevelbeplating en verschillende soorten bestrating. Niet iedere ondergrond vraagt om dezelfde behandeling. Daarom beoordelen we vooraf het materiaal, de vervuiling en de staat van het oppervlak.",
  },
  {
    q: "Hoelang blijft het resultaat zichtbaar?",
    a: "Dat verschilt per situatie. De ligging van het pand, vocht, schaduw, begroeiing en het type ondergrond hebben invloed op hoe snel nieuwe aanslag ontstaat. Omdat softwash organische vervuiling gericht behandelt, blijft het oppervlak doorgaans langer schoon dan wanneer alleen het zichtbare vuil wordt weggespoten.",
  },
  {
    q: "Is softwash veilig voor mijn dak of gevel?",
    a: "We stemmen de werkdruk, dosering en behandeling af op de ondergrond. Vooraf controleren we de staat van het oppervlak en beschermen we waar nodig planten, ramen, metalen onderdelen en andere delen van de omgeving. Beschadigde of kwetsbare ondergronden vragen soms om een aangepaste aanpak.",
  },
  {
    q: "Wat kost dak- of gevelreiniging?",
    a: "De prijs hangt onder andere af van het aantal vierkante meters, de bereikbaarheid, het type ondergrond en de mate van vervuiling. Na beoordeling van de situatie ontvang je een duidelijke en vrijblijvende offerte.",
  },
  {
    q: "Moet er altijd een proefvlak worden uitgevoerd?",
    a: "Nee. Een proefvlak is vooral nuttig wanneer vooraf niet duidelijk is hoe een ondergrond of vervuiling op de behandeling reageert. Wanneer een proefvlak nodig is, bespreken we dit vooraf.",
  },
  {
    q: "Kunnen jullie ook impregneren?",
    a: "Ja, afhankelijk van de ondergrond kunnen we een gereinigde gevel behandelen met een geschikt impregneermiddel. Dit helpt de gevel beter te beschermen tegen vocht en weersinvloeden. Vooraf beoordelen we of impregneren technisch geschikt en zinvol is.",
  },
];

export const NAV_LINKS = [
  { label: "Diensten", href: "#diensten" },
  { label: "Methode", href: "#methode" },
  { label: "Werkwijze", href: "#werkwijze" },
  { label: "Resultaten", href: "#resultaten" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];
